
/* ---------------------------------------- */
/* ---------- Masonry Grid Logic ---------- */
/* ---------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
    const masonry = document.querySelector('.masonry');
    
    function resizeMasonryItem(item){
        /* Get the grid object, its row-gap, and the size of its implicit rows */
        var grid = document.getElementsByClassName('masonry')[0],
            rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap')),
            rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));

        /*
         * Spanning for any brick = S
         * Grid's row-gap + browser's height of item content
         * divided by
         * Grid's row-gap + height of single grid row (default)
         */
        var rowSpan = Math.ceil((item.querySelector('img')?.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
        
        /* Set the spanning */
        item.style.gridRowEnd = 'span ' + rowSpan;
    }

    function resizeAllMasonryItems(){
        var allItems = document.getElementsByClassName('masonry-item');
        
        for(var i=0;i<allItems.length;i++){
            resizeMasonryItem(allItems[i]);
        }
    }

    /* Resize all the grid items on the load and resize events */
    window.onload = resizeAllMasonryItems;
    window.addEventListener('resize', resizeAllMasonryItems);

    /* Resize the items when all the images inside the grid finish loading */
var allItems = document.getElementsByClassName('masonry-item');
for (var i = 0; i < allItems.length; i++) {
    imagesLoaded(allItems[i], function(instance) {
        if (instance.elements && instance.elements.length > 0) {
            var item = instance.elements[0];
            resizeMasonryItem(item);
        }
    });
}

});

function imagesLoaded(el, callback) {
    var imgElements = el.querySelectorAll('img');
    var imgPromises = [];

    imgElements.forEach(function (img) {
        if (!img.complete) {
            imgPromises.push(new Promise(function (resolve) {
                img.onload = img.onerror = resolve;
            }));
        }
    });

    Promise.all(imgPromises).then(callback);
}

/* ------------------------------------- */
/* ----------- Parallex Logic ---------- */
/* ------------------------------------- */
window.addEventListener('scroll', function() {
  var scrollPosition = window.pageYOffset;
  var backgrounds = document.querySelectorAll('.parallax-background');
    document.body.style.backgroundPositionY = scrollPosition * 0.1 + 'px';

  backgrounds.forEach(function(bg) {
    var scrollSpeed = parseFloat(bg.getAttribute('data-scrollspeed')) || 0.5;
    var parallaxWrapper = bg.closest('.parallax-wrapper');
    var elementOffsetTop = parallaxWrapper.getBoundingClientRect().top + scrollPosition - window.innerHeight;
    var startOffset = elementOffsetTop < 0 ? 0 : elementOffsetTop;
    
    var offset = (scrollPosition - startOffset) * scrollSpeed;
    
    // Check if the element is in the viewport to apply the effect
    if(scrollPosition + window.innerHeight > startOffset) {
      bg.style.transform = 'translateY(' + offset + 'px)';
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('[data-hide]');
    
    buttons.forEach(button => {
        button.addEventListener('click', function() {
            // Get the selectors from the data-hide and data-show attributes
            const hideSelector = this.getAttribute('data-hide');
            const showSelector = this.getAttribute('data-show');

            // Hide all elements that match the data-hide selector
            const elementsToHide = document.querySelectorAll(hideSelector);
            elementsToHide.forEach(element => {
                element.style.display = 'none';
            });

            // Show the element that matches the data-show selector
            const elementToShow = document.querySelector(showSelector);
            if (elementToShow) {
                elementToShow.style.display = 'block'; // Adjust this depending on your needs
            }
        });
    });
  
  const containers = document.querySelectorAll('.hover-zoom-container');

  containers.forEach(container => {
    const image = container.querySelector('.hover-zoom');

    container.addEventListener('mousemove', function(e) {
      const rect = this.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      // Calculate the mouse position as a percentage of the container dimensions
      const xPercent = x / rect.width * 100;
      const yPercent = y / rect.height * 100;

      // Apply the calculated percentages as the transform origin for the zoom effect
      image.style.transformOrigin = `${xPercent}% ${yPercent}%`;
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
    const thumbnails = document.querySelectorAll('.product-thumbnail');

    thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', function() {
            // Remove the 'product-thumbnail-selected' class from all thumbnails
            thumbnails.forEach(thumb => {
                thumb.classList.remove('product-thumbnail-selected');
            });

            // Add the 'product-thumbnail-selected' class to the clicked thumbnail
            this.classList.add('product-thumbnail-selected');

            // Get the media ID from the clicked thumbnail
            const mediaId = this.getAttribute('data-media-id');

            // Hide all images and videos and remove hover-zoom class
            const allMedia = document.querySelectorAll('[id^="ImageFor_"]');
            allMedia.forEach(media => {
                media.classList.add('hidden');
            });

            // Find the corresponding media, unhide it, and add hover-zoom
            const selectedMedia = document.querySelector(`#ImageFor_${mediaId}`);
            if (selectedMedia) {
                selectedMedia.classList.remove('hidden');
            }
        });
    });
});


/* ------------------------------------- */
/* ---------- Selecting Logic ---------- */
/* ------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
    // This function updates the input box with selected options' data-names
    function updateSelectedSetInput() {
        const selectedOptions = document.querySelectorAll('.selected-option');
        const selectedValues = Array.from(selectedOptions).map(el => el.dataset.name).join(' ');
        document.getElementById('SelectedSetInput').value = selectedValues;
    }

    // This function handles the click events on selectable options
    function handleOptionClick(event) {
        // Ensure the clicked element has the right class
        if (!event.target.classList.contains('selectable-option')) {
            return;
        }

        const clickedElement = event.target;
        const optionGroup = clickedElement.dataset.option;

        // Find all elements with the same data-option value
        const allOptionsInGroup = document.querySelectorAll(`.selectable-option[data-option="${optionGroup}"], .selected-option[data-option="${optionGroup}"]`);

        // Remove 'selected-option' from all, add 'selectable-option'
        allOptionsInGroup.forEach(el => {
            if (el !== clickedElement) {
                el.classList.remove('selected-option');
                el.classList.add('selectable-option');
            }
        });

        // Toggle the class on the clicked element
        if (clickedElement.classList.contains('selectable-option')) {
            clickedElement.classList.remove('selectable-option');
            clickedElement.classList.add('selected-option');
        } else {
            clickedElement.classList.add('selectable-option');
            clickedElement.classList.remove('selected-option');
        }

        // Update the input field after selection changes
        updateSelectedSetInput();
    }

    // Attach event listeners to the document to handle clicks on selectable options
    document.addEventListener('click', handleOptionClick);
});


/* ------------------------------------- */
/* ------------- Cart Logic ------------ */
/* ------------------------------------- */

function getScrollbarWidth() {
    // Creating a temporary div element to calculate scrollbar width
    let outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll"; // forcing scrollbar to appear
    document.body.appendChild(outer);

    // Creating a child div and adding it to the outer div
    let inner = document.createElement("div");
    outer.appendChild(inner);

    // Calculating the difference between the outer and inner div widths, which is the scrollbar width
    let scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    // Removing the temporary divs from the document
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
}


document.querySelectorAll('.open-mobile-menu').forEach(function(button) {
    button.addEventListener('click', function() {
        const scrollbarWidth = getScrollbarWidth();
        document.querySelector('#mobile-menu').style.left = '0'; 
        document.querySelector('#dim-overlay').style.display = 'block'; 
        document.body.style.overflow = 'hidden'; 
        document.body.style.paddingRight = scrollbarWidth + 'px'; 
    });
});

var closeButton = document.getElementById('closemobilemenu');
if (closeButton) {
    closeButton.addEventListener('click', function() {
        document.getElementById('mobile-menu').style.left = '-900px'; // Hide the cart
        document.getElementById('dim-overlay').style.display = 'none'; // Hide the overlay
        document.body.style.overflow = 'auto'; // Allow scrolling again
        document.body.style.paddingRight = '0px'; // Remove padding when the scrollbar is visible again
    });
} else {
    console.log('Element with ID "closemobilemenu" does not exist.');
}

document.querySelectorAll('.open-cart').forEach(function(button) {
    button.addEventListener('click', function() {
        const scrollbarWidth = getScrollbarWidth();
        document.querySelector('#shopping-cart').style.right = '0'; 
        document.querySelector('#dim-overlay').style.display = 'block'; 
        document.body.style.overflow = 'hidden'; 
        document.body.style.paddingRight = scrollbarWidth + 'px'; 
    });
});

document.getElementById('dim-overlay').addEventListener('click', function() {
    document.getElementById('shopping-cart').style.right = '-900px'; // Hide the cart
    document.getElementById('dim-overlay').style.display = 'none'; // Hide the overlay
    document.body.style.overflow = 'auto'; // Allow scrolling again
    document.body.style.paddingRight = '0px'; // Remove padding when the scrollbar is visible again
});

document.getElementById('closecart').addEventListener('click', function() {
    document.getElementById('shopping-cart').style.right = '-900px'; // Hide the cart
    document.getElementById('dim-overlay').style.display = 'none'; // Hide the overlay
    document.body.style.overflow = 'auto'; // Allow scrolling again
    document.body.style.paddingRight = '0px'; // Remove padding when the scrollbar is visible again
});

function formatPrice(priceInCents, currencyCode = storeCurrency) {
  const price = priceInCents / 100;
  const hasFraction = price % 1 !== 0;

  return new Intl.NumberFormat('en-SE', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: hasFraction ? 2 : 0,
  }).format(price);
}

  function addItemToCart(variantId, quantity, properties) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        properties: properties
      })
    })
    .then(response => response.json())
    .then(data => {
      updateCartDisplay(); // Refresh the cart display
    })
    .catch((error) => {
      console.error('Error adding item:', error);
    });
  }

  function updateCartDisplay() {
    let totalPrice = 0;
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartContainer = document.querySelector('#shopping-cart .container');
        if (!cartContainer) {
            console.error('Cart container not found.');
            return;
        }
  
        // Clear existing cart content
        cartContainer.innerHTML = '';
  
        cart.items.forEach(item => {
          // Construct the cart item row
          const itemRow = document.createElement('div');
          itemRow.className = 'row align-items-center shadow margin-left-small margin-right-small overflow-hidden bg-white margin-bottom-1';
          
          totalPrice += item.price;
          let propertiesHtml = '';
          if (item.properties && Object.keys(item.properties).length > 0) {
            // Iterate over the properties object
            for (const [key, value] of Object.entries(item.properties)) {
              // Append each property as a line of HTML
              propertiesHtml += `<div class="text-small" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${key}: ${value}</div>`;
            }
          }
          
          itemRow.innerHTML = `
            <div class="col-2 padding-0" style="background-size: cover!important;background-repeat: round!important;background: url('${item.image}')">
              <img src="${item.image}" width="100%" style="opacity:0" />
            </div>
            <div class="col-5 break-word padding-top-1 padding-bottom-1">
              <div>${item.product_title}</div>
              ${propertiesHtml}
              <div class="text-small bold">${item.variant_title}</div>
            </div>
            <div class="col-3 text-right">
              <div class="">${formatPrice(item.price, storeCurrency)}</div>
              <div class="text-small" style="display:flex;justify-content:flex-end">        
                <button class="decrease-quantity btn-flat" data-variant-id="${item.id}">-</button>
                <span class="padding-left-1 padding-right-1">${item.quantity}</span>
                <button class="increase-quantity btn-flat" data-variant-id="${item.id}">+</button>
              </div>
            </div>
            <div class="col-2 text-right">
              <div class="text-small">
                <button class="btn-flat remove-item" data-variant-id="${item.id}">✕</button>
              </div>
            </div>`;
  
          // Append the newly created row to the cart container
          cartContainer.appendChild(itemRow);
        });
        
        document.getElementById('cart-total').innerHTML = formatPrice(totalPrice, storeCurrency);
        
        // Re-attach event listeners for the new buttons
        attachCartUpdateHandlers();
      })
      .catch(error => {
        console.error('Error fetching updated cart:', error);
      });
  }

  function attachCartUpdateHandlers() {
    document.querySelectorAll('.increase-quantity, .decrease-quantity, .remove-item').forEach(button => {
      button.addEventListener('click', function(event) {
        const variantId = event.target.getAttribute('data-variant-id');
        const action = event.target.className;

        if (action.includes('increase-quantity')) {
          changeCartItemQuantity(variantId, 1);
        } else if (action.includes('decrease-quantity')) {
          changeCartItemQuantity(variantId, -1);
        } else if (action.includes('remove-item')) {
          removeCartItem(variantId);
        }
      });
    });
  }

  function changeCartItemQuantity(variantId, quantityChange) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const item = cart.items.find(item => item.id == variantId);
        if (!item) {
          console.error('Item not found in cart');
          return;
        }
  
        const newQuantity = item.quantity + quantityChange;
  
        // If new quantity would be 0 or less, remove the item. Otherwise, update the quantity.
        if (newQuantity <= 0) {
          removeCartItem(variantId);
        } else {
          updateCartItemQuantity(variantId, newQuantity);
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }
  
  function updateCartItemQuantity(variantId, newQuantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: newQuantity
      })
    })
    .then(response => response.json())
    .then(data => {
      updateCartDisplay(); // Refresh the cart display
    })
    .catch(error => {
      console.error('Error updating quantity:', error);
    });
  }

  function removeCartItem(variantId) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(data => {
      updateCartDisplay(); // Refresh the cart display
    })
    .catch(error => {
      console.error('Error removing item:', error);
    });
  }

  updateCartDisplay();

/* --- SLIDE DOWN TOGGLE --- */
document.addEventListener("DOMContentLoaded", function() {
  const links = document.querySelectorAll('[data-slidetoggle]');

  links.forEach(function(link) {
    const targetId = link.getAttribute('data-slidetoggle');
    const target = document.querySelector(targetId);

    link.addEventListener('click', function(event) { 
      if (target) {
        const isCollapsed = target.style.maxHeight === "0px" || target.style.maxHeight === "";
        if (isCollapsed) {
          // Expand the section
          target.style.maxHeight = target.scrollHeight + "px";
        } else {
          // Collapse the section
          target.style.maxHeight = "0";
        }
      } else {
        console.error('Target element not found:', targetId);
      }
    });
  });
});


/* ------------------------------------- */
/* ------------ Modal Logic ------------ */
/* ------------------------------------- */ 
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-modal]').forEach(function(element) {
        element.addEventListener('click', function() {
            var modalId = this.getAttribute('data-modal');
            document.querySelector(modalId).style.display = 'block';
            document.body.style.overflow = 'hidden'; // Disable scrolling on body
        });
    });

    document.querySelectorAll('.close').forEach(function(element) {
        element.addEventListener('click', function() {
            this.closest('.modal').style.display = 'none';
            document.body.style.overflow = 'auto'; // Re-enable scrolling on body
        });
    });

    window.onclick = function(event) {
        if (event.target.classList.contains('modal')) {
            event.target.style.display = 'none';
            document.body.style.overflow = 'auto'; // Re-enable scrolling on body when clicking outside
        }
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const images = document.querySelectorAll('.zoom-image');
    const backdrop = document.createElement('div');
    backdrop.className = 'backdrop hidden';
    document.body.appendChild(backdrop);

    images.forEach(image => {
        image.addEventListener('click', function () {
            const enlargedImage = document.createElement('img');
            const closeButton = document.createElement('div');
            
            // Configure the close button
            closeButton.className = 'wc_close_modal';
            closeButton.innerHTML = '×';

            // Append elements
            backdrop.appendChild(closeButton);
          
            enlargedImage.src = this.src;
            enlargedImage.className = 'modal-image';
            backdrop.appendChild(enlargedImage);
            backdrop.style.display = 'flex'; // Display the backdrop with the new image
        });
    });

    backdrop.addEventListener('click', function () {
        this.style.display = 'none'; // Hide the backdrop
        while (this.firstChild) {
            this.removeChild(this.firstChild); // Remove the enlarged image
        }
    });
});


